<template>
  <div id="app">
    <Loader :isActiveStatus="stateCommon.loader.isActiveStatus"></Loader>
    <!-- The router decides what is on screen, and it is the only thing that
         does. Switching on an auth flag here as well rendered the dashboard
         shell twice: this outlet sits at depth 0, so it matched the dashboard
         route again inside the dashboard that was already mounted. Two
         sidebars, two footers, every start-up request fired twice. -->
    <router-view />
  </div>
</template>

<script>
import Loader from "@/widgets/Loader/index.vue";
import store from "@/store";
import { mapState } from "vuex";

export default {
  name: "App",
  components: {
    Loader,
  },
  computed: {
    ...mapState({
      stateCommon: "common",
    }),
  },
  created() {
    this.initTheme();
    this.appConfig();
  },
  mounted() {
    requestAnimationFrame(() => {
      document.documentElement.classList.remove("no-transition");
    });
  },
  methods: {
    initTheme() {
      const saved = localStorage.getItem("theme") || "dark";
      this.$store.commit("SET_THEME", saved);
    },
    appConfig() {
      const token = localStorage.getItem("token");
      if (token) {
        const user = localStorage.getItem("user");
        store.commit("LOGIN", {
          name: user,
          status: true,
          token,
          uhash: localStorage.getItem("uhash"),
          utype: localStorage.getItem("utype"),
          recipes_access: localStorage.getItem("recipes_access"),
          invoices_access: localStorage.getItem("invoices_access"),
          vendors_access: localStorage.getItem("vendors_access"),
          stocks_access: localStorage.getItem("stocks_access"),
        });
      } else {
        store.dispatch("logoutService");
      }
    },
  },
};
</script>
